import React from 'react';
import Link from 'next/link';
import link from '@/lib/localEndPoints'
//  types for the component props
interface CallToActionProps {
  title: string;
  description: string;
  buttonText: string;
}

export const CallToAction: React.FC<CallToActionProps> = ({ title, description, buttonText }) => {
  return (
    <div className="flex items-center justify-center relative overflow-hidden rounded-2xl border border-primary ">
      <div className="w-full  mx-auto p-4 md:p-12 z-10 ">
        <div className="text-center">
          <h2 className="text-xl lg:text-2xl font-bold text-gray-800 mb-4">
            {title}
          </h2>
          <p className="text-gray-600 text-sm md:text-base mb-4 md:mb-8 max-w-2xl mx-auto">
            {description}
          </p>
          <Link rel="preload"  prefetch href={link.CONTACT} className="px-8 py-3 bg-primary hover:bg-prime-hover text-background text-sm md:text-base font-medium rounded-full  transition-colors duration-300 cursor-pointer">
            {buttonText}
          </Link>
        </div>
      </div>
      {/* Decorative Background */}
        <div className="absolute left-0 top-0 h-full w-40 md:w-60 bg-blue-200 rounded-r-full"></div>
        <div className="absolute -right-20 top-0 md:-top-20 w-32 h-32  md:w-64 md:h-64 border-2 border-blue-200 rounded-full"></div>
        <div className="absolute -right-20 bottom-20 md:-bottom-10 w-40 h-40 md:w-90 md:h-90 border-2 border-blue-200 rounded-full"></div>
        <div className="absolute -right-20 bottom-20 md:bottom-0 w-32 h-32 md:w-72 md:h-72 border-2 border-blue-200 rounded-full"></div>
        <div className="absolute -right-20 bottom-0 md:-bottom-30 w-32 h-32 md:w-72 md:h-72 border-2 border-blue-200 rounded-full"></div>
    </div>
  );
};

